import { makeStyles } from '@material-ui/core'
import React, {useState} from 'react'
import {Drawer, Input, Form, Select} from 'antd'
import { CTAButton } from '../../components'
import { useData } from '../../../../data'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'

const useStyles = makeStyles(theme => ({
    error: {
        fontSize: 18,
        color: 'red'
    }
}))

const {Option} = Select

const NewAuthAccount = ({visible, close}) => {
    const [error, setError] = useState(null)
    const classes = useStyles()
    const [form] = Form.useForm()
    const data = useData()
    const users = data.users()

    const createAccount = vals => {
        const {password, password_confirm} = vals

        if(password !== password_confirm){
            console.log("Passwords do not match")
            return form.setFields([        //change of API, read issue- https://github.com/ant-design/ant-design/issues/24225
                {
                    name: 'password_confirm',
                    value: '',
                    errors: ["Password do not match"]    // [string]
                }
            ])
        }

        trackPromise(
            users.createAuthAccount(vals)
                .then(close)
                .catch(err => {
                    console.log(err)
                    if('detail' in err){
                        setError(err.detail)
                    }
                    setError("An error occured.")
                })
        )
    }

    const {promiseInProgress} = usePromiseTracker()

    return (
        <Drawer
            visible={visible}
            onClose={close}
            placement="right"
            closable={true}
            width={350}
            title="Create a linkedin account"
        >
            <Form
                layout="vertical"
                onFinish={createAccount}
                form={form}
            >
                <Form.Item label="Account type" name="provider" rules={[{required: true, message: 'Account type is required'}]}>
                    <Select>
                        <Option value="linkedin">Linkedin Sales Navigator</Option>
                        <Option value="work_at_startup">Work at startup</Option>
                    </Select>
                </Form.Item>
                <Form.Item label="Username" name="user_name" rules={[{required: true, message: 'Username is required'}]}>
                    <Input />
                </Form.Item>
                <Form.Item label="Password" name="password" rules={[{required: true, message: 'Password is required'}]}>
                    <Input.Password />
                </Form.Item>

                <Form.Item label="Confirm password" name="password_confirm" rules={[{required: true, message: 'Password confirmation is required'}]}>
                    <Input.Password />
                </Form.Item>

                <Form.Item>
                    <CTAButton loading={promiseInProgress} type="submit"><>Submit</></CTAButton>
                </Form.Item>
                {
                    error && (
                        <Form.Item>
                            <p className={classes.error}>{error}</p>
                        </Form.Item>
                    )
                }

            </Form>
        </Drawer>
    )
}

export default NewAuthAccount
